<template>
  <div>
    <div class="info-box">
      <div class="info-card">
        <div class="card-title">班级累计可消课时</div>
        <div class="card-num">{{ baseInfo.stuClassesTotal }}</div>
      </div>
      <div class="info-card">
        <div class="card-title">班级累计已消课时</div>
        <div class="card-num">{{ baseInfo.stuFinClassesTotal }}</div>
      </div>
      <div class="info-card">
        <div class="card-title">班级累计待消课时</div>
        <div class="card-num">{{ canConsumeHour }}</div>
      </div>
    </div>
    <div class="table-box">
      <Table
        ref="dataTable"
        border
        :columns="hourColumn"
        :data="hourData"
      >
        <template slot="stuClassesTotal" slot-scope="{ row }">
          <span>{{ Number(row.stuClassesTotal) - Number(row.stuFinClassesTotal) }}</span>
        </template>
      </Table>
      <Page
        :total="pageInfo.total"
        show-total
        :current="pageInfo.pageNum"
        class="page-right"
        @on-change="handleGetPage"
      ></Page>
    </div>
  </div>
</template>
<script>
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
// 课消概况
export default {
  props: {
    baseInfo: {
      type: Object,
      default: () => {}
    },
    classroomId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      hourColumn: [
        {
          title: '学生姓名',
          key: 'studentName',
          minWidth: 150,
          align: 'center'
        },
        {
          title: '已消课时',
          key: 'stuFinClassesTotal',
          minWidth: 150,
          align: 'center'
        },
        {
          title: '待消课时',
          slot: 'stuClassesTotal',
          minWidth: 150,
          align: 'center'
          // render: (h, params) => {
          //   return h('div', [Number(params.row.stuClassesTotal) - Number(params.row.stuFinClassesTotal)]);
          // }
        }
      ],
      hourData: [],
      pageInfo: {
        total: 1,
        pageSize: 10,
        pageNum: 1
      }
    };
  },
  computed: {
    // 班级累计可消课时 = 班级累计可消课时 - 班级累计可消课时
    canConsumeHour() {
      const calcHour = Number(this.baseInfo.stuClassesTotal) - Number(this.baseInfo.stuFinClassesTotal);
      return calcHour || 0;
    }
  },
  // created() {
  //   this.getStudentsList();
  // },
  mounted() {
    this.getStudentsList();
  },
  methods: {
    handleGetPage(page) {
      this.pageInfo.pageNum = page;
      this.getStudentsList();
    },
    // 获取学生列表
    async getStudentsList() {
      const params = {
        classroomId: this.classroomId,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
      const res = await courseSchedulCenter.getClassPartitionStudents(params);
      if (res.status === 200) {
        this.hourData = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.info-box{
  display: flex;
  margin: 24px 0;
  .info-card{
    width: 30%;
    padding: 16px;
    border-radius: 4px;
    background: rgba(0,0,0,0.03);
    .card-num{
      font-size: 24px;
      font-weight: bold;
      margin-top: 8px;
    }
  }
  .info-card+.info-card{
    margin-left: 5%;
  }
}
.page-right{
  text-align: right;
  margin-top: 16px;
}
</style>
